'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _updateBlockMetadata = require('../../customRichUtils/updateBlockMetadata');

var _updateBlockMetadata2 = _interopRequireDefault(_updateBlockMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (getEditorState, setEditorState) {
    return function (block, metadata) {
        var editorState = getEditorState();
        var newEditorState = (0, _updateBlockMetadata2.default)(editorState, block, metadata);
        setEditorState(newEditorState);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/richUtils/wrappedUpdateBlockMetadata.js
// module id = 1743
// module chunks = 0